import React from 'react';
import { CustomAvatar, AvatarProps } from './styles';

const Avatar: React.FC<AvatarProps> = props => {
  return props.name ? <CustomAvatar {...props} /> : <p>...</p>;
};

export default Avatar;
